import { Box } from '@mui/system';
import { getUserPlatform } from 'modules/employees/add-edit-employee-modal/helpers';
import {
  IPBackground,
  IPButton,
  IPContainer,
  IPLinkToOnboarding,
  IPSalesPitch,
  IPTitle,
} from 'modules/employees/add-edit-employee-modal/styles';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  SET_PASSWORD__TITLE,
  WE_HAVE_AN_APP__CONTINUE_ON_WEB,
  SET_PASSWORD_APP__GO_TO_APP_STORE,
  SET_PASSWORD_APP__SELLING_POINT,
} from 'translations/constants';

interface LocationState {
  from?: string;
}

const SetPasswordApp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const state = location.state as LocationState | undefined;
  const from = state?.from || '/';

  const handleDownloadAppClick = () => {
    const platform = getUserPlatform();
    if (platform === 'Android') {
      window.open('https://play.google.com/store/apps/details?id=com.updatepro.mobile', '_blank');
    } else if (platform === 'iOS') {
      window.open('https://apps.apple.com/ro/app/uportal/id6739351774', '_blank');
    }
  };

  return (
    <IPBackground>
      <IPContainer>
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" p="25px">
          <IPTitle>{t(SET_PASSWORD__TITLE)}</IPTitle>
          <IPSalesPitch variant="body1">{t(SET_PASSWORD_APP__SELLING_POINT)}</IPSalesPitch>
          <IPButton text={t(SET_PASSWORD_APP__GO_TO_APP_STORE)} onClick={handleDownloadAppClick} />
          <IPLinkToOnboarding onClick={() => navigate(`${from}?skipMobile=true`)} sx={{ marginTop: '16px' }}>
            {t(WE_HAVE_AN_APP__CONTINUE_ON_WEB)}
          </IPLinkToOnboarding>
        </Box>
      </IPContainer>
    </IPBackground>
  );
};

export default SetPasswordApp;
